export function getObjetIndexByKey(array, key, value, debug) {
    const object = array.filter(item => {

        // if (debug) {
        //     console.log(item, value);
        // }

        return item[key] === value;
    })[0];
    return array.indexOf(object);
}

/**
 * [biggestNumberInArray Return the highest number in an array]
 * @param  {Array} array [The array to test]
 * @return {number} [The highest number of the array]
 */
// export function biggestNumberInArray(array) {
//     return array.reduce((m, c) => c > m ? c : m);
// }

export function getHighestObjectByKey(array, key) {

    let highest;

    for (var i = array.length - 1; i >= 0; i--) {

        if (highest) {
            if (array[i][key] > highest[key]) {
                highest = array[i];
            }
        } else {
            highest = array[i];
        }
    }

    return highest;
}